import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import TimeseriesSelect from './TimeseriesSelect'
import * as TimeseriesActionCreators from '../../actions/timeseries'

class TimeseriesSelectContainer extends React.Component {
  static propTypes = {
    unitId: PropTypes.number.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: 0,
  }

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.update()
  }

  update() {
    const { unitId, timeseriesActions } = this.props
    timeseriesActions.listUnitTimeseries(unitId)
  }

  unitTimeseries() {
    const {
      unitId, timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[unitId] || []
    return tsIds.map((tsId) => timeseries[tsId])
  }

  render() {
    const {
      unitId, timeseries, timeseriesByUnit, timeseriesActions, ...props
    } = this.props
    const unitTimeseries = this.unitTimeseries()
    return (<TimeseriesSelect timeseries={unitTimeseries} {...props} />)
  }
}

export default connect(
  TimeseriesSelectContainer.mapStateToProps,
  TimeseriesSelectContainer.mapDispatchToProps,
)(TimeseriesSelectContainer)
